import { render, staticRenderFns } from "./MessagePanel.vue?vue&type=template&id=21f6b168&scoped=true&"
import script from "./MessagePanel.vue?vue&type=script&lang=js&"
export * from "./MessagePanel.vue?vue&type=script&lang=js&"
import style0 from "./MessagePanel.vue?vue&type=style&index=0&id=21f6b168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6b168",
  null
  
)

export default component.exports